module.exports = __webpack_public_path__ + "static/media/wave-left.440c5f4e.webp";